import { render } from "./PaymentListPage.vue?vue&type=template&id=756a3dba&ts=true"
import script from "./PaymentListPage.vue?vue&type=script&lang=ts"
export * from "./PaymentListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__